import { render, staticRenderFns } from "./DefinedBenefitReportPage.vue?vue&type=template&id=172d8792&"
import script from "./DefinedBenefitReportPage.vue?vue&type=script&lang=ts&"
export * from "./DefinedBenefitReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports